import React from 'react';
import { LinearProgress, Typography, Box } from '@mui/material';
import { formatPercentage } from '../../utils/formatters';

/**
 * ProgressBar component for displaying completion percentage
 * @param {Object} props - Component props
 * @param {Number} props.percentage - Completion percentage (0-100)
 * @param {Boolean} props.showLabel - Whether to show the percentage label
 * @param {Object} props.style - Additional style properties
 * @returns {JSX.Element} ProgressBar component
 */
const ProgressBar = ({ percentage = 0, showLabel = true, style = {} }) => {
  // Ensure percentage is between 0 and 100
  const validPercentage = Math.min(Math.max(percentage, 0), 100);
  
  // Determine color based on percentage
  const getColor = (percent) => {
    if (percent < 33) return 'error';
    if (percent < 67) return 'warning';
    return 'success';
  };
  
  return (
    <Box style={{ width: '100%', ...style }}>
      <LinearProgress 
        variant="determinate" 
        value={validPercentage} 
        color={getColor(validPercentage)}
        style={{ height: 8, borderRadius: 4 }}
      />
      
      {showLabel && (
        <Typography 
          variant="caption" 
          style={{ 
            display: 'block', 
            textAlign: 'right',
            marginTop: 4,
            color: 'rgba(0, 0, 0, 0.6)'
          }}
        >
          {formatPercentage(validPercentage)}
        </Typography>
      )}
    </Box>
  );
};

export default ProgressBar;
